/**
 * Created by Administrator on 2017-09-02.
 */
import React,{Component} from 'react'
import {Row,Col,Icon} from 'antd'
import telephone from "../images/pc/telephone.png"
import email from '../images/pc/email.png'
export  default  class NewsFooter extends Component {
  render() {
    return (
      <footer className="copyRight">
        {/* <Row>
         
          <Col span={24} style={{textAlign:'center'}}>
            <p className="Copyright">Copyright <Icon type="copyright"/> 2018 好未来版权所有 北京世纪好未来教育科技有限公司 京ICP备13017119号</p>
          </Col>
          
        </Row> */}
        <div className="left">
            <ul className="contact">
              contact
            </ul>
            
          </div>

          <div className="code">
            share
          </div>
          
      </footer>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/news_footer.js